import { render, staticRenderFns } from "./widget_open_positions.vue?vue&type=template&id=dab6a276&scoped=true&"
import script from "./widget_open_positions.vue?vue&type=script&lang=js&"
export * from "./widget_open_positions.vue?vue&type=script&lang=js&"
import style0 from "./widget_open_positions.vue?vue&type=style&index=0&id=dab6a276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab6a276",
  null
  
)

export default component.exports